import React from 'react';
import GoogleMapReact from 'google-map-react';
import ResultMapMarker from './ResultMapMarker';
import { Button } from 'material-ui';
import ResultMapPopUp from './ResultMapPopUp';

// Return map bounds based on list of places
const getMapBounds = (map, maps, places) => {
    const bounds = new maps.LatLngBounds();

    places.forEach((place) => {
        bounds.extend(new maps.LatLng(
            place.location.lat,
            place.location.lng,
        ));
    });
    return bounds;
};

// Fit map to its bounds after the api is loaded
const apiIsLoaded = (map, maps, places) => {
    // Get bounds by our places
    const bounds = getMapBounds(map, maps, places);
    // Fit map to bounds
    map.fitBounds(bounds);
    map.setOptions({
        fullscreenControl: false
    });
    // Bind the resize listener
    ///bindResizeListener(map, maps, bounds);
};

class ResultMapContent extends React.Component {


    constructor(props) {
        super(props);
        this.state = {
            hotel: null,
        };
    }

    static defaultProps = {
        center: { lat: 0, lng: 0 },
        zoom: 11
    };

    componentDidUpdate(prevProps) {
        if (this.props && this.props.hotels && !prevProps.hotels) {
            this.centerMap();
        }
        if (this.props && this.props.hotels && prevProps.hotels &&
            this.props.hotels !== prevProps.hotels) {

            this.centerMap();
        }

    }

    centerMap = () => {
        if (this.map) {
            const bounds = getMapBounds(this.map, this.maps, this.markers);
            // Fit map to bounds
            this.map.fitBounds(bounds, 15);
            if (this.markers && this.markers.length < 2) {
                //10 city - 15 Street
                this.map.setZoom(15);
            }
        }
    }

    _onChildClick = (key, childProps) => {
        //this.props.onCenterChange([childProps.lat, childProps.lng]);
    }

    _onChildMouseEnter = async (key, childProps) => {
        const markerId = key;
        const hotelItem = this.markers.find(m => m.code === markerId);

        this.setSelectionPrices(hotelItem);
        await this.setState({ hotel: hotelItem });
    }
    setSelectionPrices(hotel) {
        let defaultSelectedRooms = {};
        hotel.rooms.forEach(
            r =>
                (defaultSelectedRooms[r.order] = {
                    order: r.order,
                    adults: r.adults,
                    kids: r.kids,
                    option: r.options[0],
                }),
        );

        let selectedOptions = Object.values(defaultSelectedRooms).map(r => r.option);
        hotel.minTotalPrice = selectedOptions.reduce((acc, curr) => acc + curr.price, 0);
        hotel.minTotalRetailPrice = selectedOptions.reduce((acc, curr) => acc + curr.retailPrice, 0);

        let allOffers = [];
        if (selectedOptions) {
            selectedOptions.forEach((room) => {
                allOffers = allOffers.concat(room.offer);
            });
        }
        allOffers = allOffers.filter((item, index, self) => index === self.findIndex((t) => (t.codeType === item.codeType)));
        hotel.totalOffers = allOffers;
    }

    _onChildMouseLeave = (key, childProps) => {
        this.setState({ hotel: null });
    }

    onMarkerClick = async (hotel) => {
        if (this.map) {
            //panTo lo hace animadito. setCenter no
            //this.map.panTo(hotel.location);
            //10 city - 15 Street
            //this.map.setZoom(10);
            //this.map.setCenter(hotel.location);
        }
        await this.setState({ hotel: hotel });
    }

    render() {
        const { t, nights, currentUser } = this.props;

        const B2bVerPVP = currentUser ? currentUser.authorities.includes('B2bVerPVP') : false;
        const markers = this.props.hotels ? this.props.hotels : [];
        this.markers = markers;

        return (
            markers && markers.length ?
                <div style={{ marginBottom: 18, marginLeft: 12 }}>
                    <div style={{ height: '100vh', maxHeight: 480, width: '100%' }} id="resultMapDivContainer">
                        <ResultMapPopUp t={t} hotel={this.state.hotel}
                            showPVP={B2bVerPVP}
                            nights={nights} />
                        <GoogleMapReact
                            defaultCenter={this.props.center}
                            yesIWantToUseGoogleMapApiInternals={true}
                            fullscreenControl={false}
                            bootstrapURLKeys={{ key: process.env.REACT_APP_GMAPS_API_KEY_BILLING }}
                            defaultZoom={10}
                            onChildMouseEnter={(key, cp) => {
                                this._onChildMouseEnter(key, cp);
                            }}
                            onChildMouseLeave={this._onChildMouseLeave}
                            onGoogleApiLoaded={({ map, maps }) => {
                                this.map = map;
                                this.maps = maps;
                                apiIsLoaded(map, maps, markers);
                            }}>
                            {markers.map(hotel => (
                                <ResultMapMarker
                                    key={hotel.code}
                                    hotel={hotel}
                                    displayedTip={false}
                                    text={hotel.name} onClick={(event) => {
                                        this.onMarkerClick(hotel);
                                        if (this.props.onMarkerClick) {
                                            this.props.onMarkerClick(hotel);
                                        }
                                    }}
                                    lat={hotel.location.lat}
                                    lng={hotel.location.lng}
                                />
                            ))}
                        </GoogleMapReact>
                    </div>
                    <Button onClick={() => this.centerMap()}>{t('COMMON.CENTER_TO_FIT')}</Button>

                </div> : ''
        );
    }
}
//export default translate('translations')((ResultMapContent));
export default ResultMapContent;


// WEBPACK FOOTER //
// ./src/components/Results/ResultMapContent.js